import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'

const DriveModeFilter = ({ setDriveMode, value }) => {
  const options = [
    {
      label: 'Campus Drive',
      value: 'CAMPUS_DRIVE',
    },
    {
      label: 'Pool Drive',
      value: 'POOL_DRIVE',
    },
    {
      label: 'Virtual Drive',
      value: 'VIRTUAL_DRIVE',
    },
  ]

  const onChange = checkedValues => {
    setDriveMode(checkedValues)
  }
  return (
    <FilterCheckBoxComp options={options} value={value} onChange={onChange} />
  )
}

export default DriveModeFilter
